module.exports = __webpack_public_path__ + "366348c8fb3553efd9f05ad788f5adc0.MP3";